module.exports = {"audiences":["alphaEnglishMembers","englishMembers"],"experimentAllocation":{"alphaEnglishMembers":1,"englishMembers":0.5},"experimentVersion":"v2","bucketVersion":"v2","defaultWeight":1,"autoTrack":true,"defaults":{"enabled":false},"variations":[{"name":"enabled","weight":1,"values":{"enabled":true}}]}


//////////////////
// WEBPACK FOOTER
// ./app/scripts/lib/experiments/config/createBoardWithBackground.json
// module id = wHAc
// module chunks = 0